import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const nameMap: Record<string, string> = {
  "": "首页",
  category: "视频分类",
  article: "视频详情",
  about: "关于我们",
  "91-video": "91视频",
  "97-video": "97视频",
  "51-video": "51视频",
  "hot-video": "热门推荐",
  "new-video": "最新上线",
};

export default function Breadcrumb() {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);

  if (segments.length === 0) return null;

  const items = [
    { label: "首页", path: "/" },
    ...segments.map((seg, i) => ({
      label: nameMap[seg] || seg,
      path: "/" + segments.slice(0, i + 1).join("/"),
    })),
  ];

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3 max-w-screen-2xl mx-auto">
      <ol className="flex items-center gap-1 text-sm flex-wrap">
        {items.map((item, i) => (
          <li key={item.path} className="flex items-center gap-1">
            {i > 0 && (
              <span className="text-foreground-400 mx-1">/</span>
            )}
            {i < items.length - 1 ? (
              <Link
                to={item.path}
                className="text-foreground-500 hover:text-primary-500 cursor-pointer transition-colors whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}